import {Rule} from './Rule';

export function makeRules(rawServices) {
  return (rawServices || []).map((s) => new Rule(s));
}